module.exports = __webpack_public_path__ + "assets/img/mecha-btn-9a132b9c.png";